module.exports = __webpack_public_path__ + "img/banner.bf17efd0.png";